import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import { onWidthResize, offWidthResize } from '../utils/resize.js';

gsap.registerPlugin(SplitText);

export default class PublishersList {
  constructor(container) {
    this.container = container;
    this.title = this.container.querySelector('.list-section__title');

    if (!this.title) return;

    this.text_lines = new SplitText(this.title, { type: 'lines,words', linesClass: 'lineParent' });

    this.init();
  }

  init = () => {
    const tl = gsap.timeline({ delay: 0.2 });
    tl.fromTo(
      this.text_lines.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 1.6,
        stagger: { each: 0.3, ease: 'power.out', from: 'start' },
        ease: 'power3.out',
        onComplete: () => onWidthResize(this.onResize),
      }
    );
  };

  onResize = () => {
    this.text_lines.revert();
    offWidthResize(this.onResize);
  };
}
